<script lang="ts">
	import { devices_settings, devices_status } from 'src/stores/device-runtime/status';
	import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { devices } from 'src/stores/lists/devices';
	import { format } from '../../services/i18n';

	//Design system components
	import { toast, Button, Text } from '@Shelly/shelly-design-system';
	import { get_gen_2_component_channel_structure, real_id } from '../../helpers/interface_helpers';
	import PositionList from '../Lists/PositionList.svelte';
	import { pin_unlocked_devices } from 'src/stores/device-runtime/pin-unlocked';
	import { gen2Request } from '../../services/gen_2_http_reqs';
	import PositionPicker from './PositionPicker.svelte';
	import { onSettingsResponse } from '../../helpers/device_settings_helpers';
	import PinUnlock from '../PinUnlock.svelte';
	import { unlockPin } from '../../helpers/pin_lock_helpers';

	export let device;

	$: pinLocked =
		typeof $pin_unlocked_devices[device.id] === 'undefined' && $devices[device.id]?.pin_lock;

	$: settingsStore = getDeviceSettings(device.id);
	$: settings = $settingsStore;
	let favorites = settings.sys.ui_data.cover
		.split(',')
		?.filter((m) => m.length > 0) //because settings?.sys?.ui_data?.cover may be ''(empty string)
		?.map(
			(p) =>
				(p = {
					pos: p,
					labels: [{ value: `${p}%`, icon: 'fa-solid fa-blinds' }],
				}),
		);

	let showModal = false;
	let showModalPinLock = false;
	let loading = false;
	let statusStore = getDeviceStatus(device.id);
	let _status = $statusStore;
	let pickerValue = 0;
	let pickerIndex;

	$: text = favorites.length > 0 ? $format('favorite_posiotions') : $format('empty_list');

	const sendRequest = async () => {
		const positions = Object.values(favorites)
			.map((x: { pos? }) => (x = x.pos))
			.join(',');
		const params = { config: { ui_data: { cover: positions } } };
		const res = await gen2Request(device, 'Sys.SetConfig', params);
		if (res.isok) {
			settings.sys.ui_data.cover = positions;
			devices_settings.update_devices_settings(device.id, settings);
		}
		onSettingsResponse(res, device); //ToDo need keys for gen2
		pickerIndex = undefined;
		pickerValue = undefined;
	};
	const handleSave = (e) => {
		const _index = e.detail.index;
		const _value = e.detail.value;
		let _favorites = favorites;
		if (typeof _index !== 'undefined') {
			_favorites.splice(_index, 1, {
				pos: _value,
				labels: [{ value: `${_value}%`, icon: 'fa-solid fa-blinds' }],
			});
		} else {
			_favorites.push({
				pos: _value,
				labels: [{ value: `${_value}%`, icon: 'fa-solid fa-blinds' }],
			});
		}
		favorites = _favorites;
		sendRequest();
	};

	const setPosition = async (e) => {
		//this may will be deprecated, not sure
		loading = true;
		const position = e.detail;

		const params = { id: 0, pos: position };
		const res = await gen2Request(device, 'Cover.GoToPosition', params);
		if (res.isok) {
			_status[`${get_gen_2_component_channel_structure(device)}`].current_pos = position;
			devices_status.update_device_status({
				id: device.id,
				msg: _status,
			});
		} else {
			toast.open({
				type: 'danger',
				title: $format('device_control_failed_long'),
			});
		}
		loading = false;
	};

	const handleAdd = () => {
		if (!pinLocked) {
			showModal = true;
		} else {
			showModalPinLock = true;
		}
	};
	const handleEdit = (e) => {
		if (!pinLocked) {
			pickerIndex = e.detail.index;
			pickerValue = favorites[pickerIndex].pos;
			showModal = true;
		} else {
			showModalPinLock = true;
		}
	};

	const handleDelete = (e) => {
		if (!pinLocked) {
			const _index = e.detail.index;
			let _favorites = favorites;
			if (_favorites.length > 1) {
				_favorites.splice(_index, 1);
			} else {
				_favorites = [];
			}
			favorites = _favorites;
			sendRequest();
		} else {
			showModalPinLock = true;
		}
	};

	const handlePin = () => {
		pinLocked = unlockPin(device, pinLocked);
	};

	const handleClose = () => {
		// value = valueCache;
	};
</script>

<Text class="text-bold mb-s mt-l">{text}</Text>

<PositionList
	bind:favorites
	{loading}
	on:set={setPosition}
	on:delete={handleDelete}
	on:edit={handleEdit}
/>

<Button size="m" class="mb-s" variant="secondary" on:click={handleAdd}>
	{$format('button_add')}
</Button>
{#if showModal}
	<PositionPicker
		bind:showModal
		value={pickerValue}
		index={pickerIndex}
		{device}
		on:save={handleSave}
	/>
{/if}

{#if showModalPinLock}
	<PinUnlock
		bind:showModal={showModalPinLock}
		on:unlock={handlePin}
		on:close={handleClose}
		on:cancel={() => (showModalPinLock = false)}
	/>
{/if}
